export default __webpack_public_path__ + "static/media/chain-20.d8c87827.png";